import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { data } from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { AppState } from '../app.service';
import { CordovaService } from '../cordova.service';
import { Option } from '../option/option.model';
import { Path } from '../path/path-v2.model';
import { Poll, PollStats } from '../poll/poll.model';
import { PollService } from '../poll/poll.service';
import { SpinnerService } from '../spinner.service';
import { ToasterService } from '../toaster.service';
import { User } from '../user/user.model';
import { PopoverController } from '@ionic/angular';
import { PopoverComponent } from '../shared/popover/popover.component';
import { I18n } from '../i18n.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HomeUiService } from '../new-design/home-ui.service';
import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { slideInDownAnimation } from 'angular-animations';

@Component({
  selector: 'first90-force-rank',
  templateUrl: './force-rank.component.html',
  styleUrls: ['./force-rank.component.scss'],
  animations: [
      slideInDownAnimation({duration:300}),
      trigger('animateContent', [
        transition(':enter', [
          query(':scope > *', [
            style({ opacity: 0, transform: 'translateY(8px)' })
          ], { optional: true }),
  
          query(':scope > *', [
            stagger(100, [
              animate(
                '800ms cubic-bezier(0.76, 0, 0.24, 1)',
                style({ opacity: 1, transform: 'translateY(0)' })
              )
            ])
          ], { optional: true })
        ]),
  
        transition(':leave', [
          animate(
            '0.3s cubic-bezier(0.76, 0, 0.24, 1)',
            style({ opacity: 0, transform: 'translateY(-75px)' })
          )
        ])
      ])
    ]
})
export class ForceRankComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() poll
  @Input() isPreview: boolean
  @Input() inverted = false
  @Input() progressItems = []
  @Input() currentIndex = 0
  @Input() screenId: any
  @Input() chapterIndex: number;
  @Input() stepIndex: number  
  @Input() animationClass: boolean = false;
  @ViewChild('questionRef') questionRef: ElementRef;
  // @Output() dataEvent = new EventEmitter<any>();
  
  enabled = true // TODO: Get it from the path
  nameTQ: string // TODO: Get it from the path
  nameHYPA: string // TODO: Get it from the path
  path: Path
  // stats: PollStats
  stats: any
  status: string
  chart = []
  loading: boolean = true;
  isMobileWebIos = false;
  isMobileWeb=false;
  statsPer: number[]
  currentUser: User

  optionIds: number[]
  optionsList: any
  listItems: any;
  finalizedOptionIds =[];
  @Input() enableFinalizeButton: boolean;
  showScrollHint = false;
  isMobile: boolean;
  innerQuestionHtml: any;
  @Output() blurCard= new EventEmitter<any>();
  private _forceList: any;
  @ViewChild('forceList', { static: false })
  set forceList(ref: any) {
    this._forceList = ref;
    const el = ref?.el || ref;
    if (el) {
      this.initScrollHintObserver(el);
    } else {
      this.scrollHintResizeObserver?.disconnect();
      this.scrollHintMutationObserver?.disconnect();
    }
  }
  get forceList(): any {
    return this._forceList;
  }
  private scrollHintResizeObserver?: ResizeObserver;
  private scrollHintMutationObserver?: MutationObserver;
  enableFinalize = false;
  constructor(
    private pollService: PollService,
    private appState: AppState,
    private spinnerService: SpinnerService,
    private cordovaService: CordovaService,
    private tostrService: ToasterService,
    private cdRef: ChangeDetectorRef, // LUMBA-1308
    private popover:PopoverController,
    private i18n: I18n,
    public homeUIService: HomeUiService,
    private render: Renderer2,
    private _sanitizer: DomSanitizer,
  ) {
    this.currentUser = this.appState.get('currentUser')
    this.path = this.appState.get('currentPath')
    this.isMobile = this.appState.get('isMobile');
    // this.isEnabled()
    // this.initNames()
  }

  ngOnInit() {
    this.innerQuestionHtml = this._sanitizer.bypassSecurityTrustHtml(this.poll?.screen?.content?.question ?? '');
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    console.log("this.isMobileWeb value", this.isMobileWeb);
    this.loading = false;
    if (this.poll && this.poll?.screen?.isCompleted) {
      this.enableFinalizeButton = false;
    } else {
      this.enableFinalizeButton = true;
      const selections = this.appState.get('forceRankSelections') ?? {};
      const cached: number[] = selections?.[this.poll?.screenContentId];
      if (cached?.length) {
        this.optionIds = cached;
        this.finalizedOptionIds = cached;
        const options = this.poll?.screen?.content?.options;
        if (options?.length) {
          const orderMap = new Map(cached.map((id: number, i: number) => [id, i]));
          options.sort((a: any, b: any) => (orderMap.get(a.optionId) ?? 0) - (orderMap.get(b.optionId) ?? 0));
        }
      }
    }
  }
 
 enableBlur(val) {
  this.enableFinalizeButton=val;
 // if(this.enable)
    this.blurCard?.emit({
      enable: this.enableFinalizeButton,
      poll: this.poll
    })
    
}
  ngAfterViewInit() {
    setTimeout(() => {
    this.changeSubTextFont();
  }, 100);
    if (this.poll?.screen?.isCompleted) {
      // this.spinnerService.on()
      // this.getRankAnswers(this.poll?.screen?.userResponse)
      this.enableFinalizeButton = false
      this.optionsList = this.poll?.screen?.content?.options
      // this.spinnerService.off()
      this.stats = this.poll?.screen?.userResponse?.stats
      this.setStats()
    }
     const el = this.forceList?.el || this.forceList;

    if (el) {
      el.addEventListener('scroll', this.detectScrollStart.bind(this), { passive: true });
    }
  }

  detectScrollStart(event: any) {
    if (!this.showScrollHint) {
      this.showScrollHint = true;
    }
  }

  onListScroll(event: any) {
    // fallback for ionic scroll events — triggers same logic
    if (!this.showScrollHint) {
      this.showScrollHint = true;
    }
  }

  private initScrollHintObserver(el: HTMLElement): void {
    this.scrollHintResizeObserver?.disconnect();
    this.scrollHintMutationObserver?.disconnect();
    this.updateShowScrollHint(el);

    // The container's own box size stays fixed, so a ResizeObserver on it alone
    // won't fire when reordering/finalizing changes the list content's scrollHeight.
    this.scrollHintResizeObserver = new ResizeObserver(() => this.updateShowScrollHint(el));
    this.scrollHintResizeObserver.observe(el);

    this.scrollHintMutationObserver = new MutationObserver(() => this.updateShowScrollHint(el));
    this.scrollHintMutationObserver.observe(el, { childList: true, subtree: true, characterData: true });
  }

  private updateShowScrollHint(el: HTMLElement): void {
    this.showScrollHint = el.scrollHeight > el.clientHeight;
    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.scrollHintResizeObserver?.disconnect();
    this.scrollHintMutationObserver?.disconnect();
  }

  scrollToBottom() {
    const el = this.forceList?.el || this.forceList;

    el.scrollTo({
      top: el.scrollHeight,
      behavior: 'smooth'
    });
  }

  ngOnChanges(changes: SimpleChanges) {
  if (changes['poll']) {
    this.innerQuestionHtml = this._sanitizer.bypassSecurityTrustHtml(
      this.poll?.screen?.content?.question ?? ''
    );
    setTimeout(() => {
      this.changeSubTextFont();
      this.cdRef.detectChanges();
    }, 100);
  }
  if (!changes['poll'] || changes['poll'].firstChange) { return false; }
}

 changeSubTextFont(): null {
  if (this.questionRef?.nativeElement) {
    this.applyStylesToAllInnerTags(this.questionRef.nativeElement);
  }
  return null;
}

  applyStylesToAllInnerTags(element: HTMLElement) {
  if (!element) { return; }
  const childElements = Array.from(element.children);
  childElements.forEach((childElement: Element) => {
    const tagName = childElement.tagName.toLowerCase();

    if (tagName === 'ol' || tagName === 'ul') {
      this.render.setStyle(childElement, 'list-style', 'none');
      this.render.setStyle(childElement, 'padding-left', '1.5em');
    }

    if (tagName === 'li') {
      const dataList = childElement.getAttribute('data-list');

      const qlUi = childElement.querySelector('.ql-ui');
      if (qlUi) {
        this.render.setStyle(qlUi, 'display', 'none');
      }

      if (dataList === 'bullet') {
        this.render.setStyle(childElement, 'list-style-type', 'disc');
        this.render.setStyle(childElement, 'display', 'list-item');
        this.render.setStyle(childElement, 'margin-left', '1em');
      } else if (dataList === 'ordered') {
        this.render.setStyle(childElement, 'list-style-type', 'decimal');
        this.render.setStyle(childElement, 'display', 'list-item');
        this.render.setStyle(childElement, 'margin-left', '1em');
      }
    }

    this.applyStylesToAllInnerTags(childElement as HTMLElement);
  });
}

  // setStats() {
  //   if (!this.stats) {
  //     return
  //   }

  //   const total = this.stats.reduce((sum, n) => sum + n)
  //   if (!total) {
  //     return
  //   }

  //   this.statsPer = this.stats.map(n => Math.floor(n * 100 / total))
  // }

   setStats() {
    if (!this.stats) {
      return
    }
    if (!this.stats?.data) {
      return
    }
    if (!this.stats.data.length) {
      return
    }

    const total = this.stats.data.reduce((sum, n) => sum + n)
    if (!total) {
      return
    }

    this.statsPer = this.stats.data.map(n => Math.round(n * 100 / total))
    console.log("statsPer",this.statsPer)
  }

  private isEnabled() {
    this.enabled = this.path?.enabledAttributes['polls']
  }

  private initNames() {
    this.nameTQ = this.path.getCustomText('p_tq')
    this.nameHYPA = this.path.getCustomText('p_hypa')
  }

  @HostListener('click', ['$event'])
  onLinkClick(e) {
    if (e.target.tagName.toLowerCase() === 'a' && e.target.target === '_blank') {
      if (this.cordovaService.onCordova) {
        e.stopPropagation()
        e.preventDefault()
        this.cordovaService.openLinkInBrowser(e.target.href)
      } else {
        window.open(e.target.href, '_blank')
      }
    }
  }

  getRankAnswers(userId,pathId,questionId) {
    const requestData = {
      'user_id': userId,
      'path_id': pathId,
      'force_question_id': questionId
    }

    this.pollService.getForceRankAnswers(requestData).subscribe(
      (response) => {
        this.enableFinalizeButton = false
        this.optionsList = response.data.options
        // this.spinnerService.off()
        this.stats = response.data.stats
        this.setStats()
      },
      (error) => {
        // this.spinnerService.off()
        console.log('error :', error);
      }
    )
  }

  onRenderItems(event) {
    this.listItems = this.poll?.screen?.content?.options;
    let draggedItem = this.listItems.splice(event.detail.from, 1)[0];
    this.listItems.splice(event.detail.to, 0, draggedItem);
    event.detail.complete();

    let idsArray = [];
    this.listItems.forEach(element => {
      idsArray.push(element);
    });

    this.optionIds = idsArray.map(item => item.optionId);
    this.finalizedOptionIds = this.optionIds;

    const selections = this.appState.get('forceRankSelections') ?? {};
    selections[this.poll?.screenContentId] = this.optionIds;
    this.appState.set('forceRankSelections', selections);
  }

  finalizeAnswer() {
    if (this.finalizedOptionIds?.length <= 0 && !this.optionIds) {
      this.optionIds = this.poll?.screen?.content?.options?.map(item => item.optionId);
      this.finalizedOptionIds = this.optionIds;
    }
    const selections = this.appState.get('forceRankSelections') ?? {};
    delete selections[this.poll?.screenContentId];
    this.appState.set('forceRankSelections', selections);
    this.setRank(this.poll);
  }
  toggleTheme() {
    this.homeUIService.toggleTheme();
    this.cdRef.detectChanges(); 
  }
  setRank(poll) {
    const requestData = {
      step_id:this.poll?.stepId,
      screen_id:this.poll?.screenId,
      screen_content_id: this.poll?.screenContentId,
      option_id: this.finalizedOptionIds
    }
    if (!requestData.option_id) {
      // this.spinnerService.off()
    } else {
      // this.spinnerService.on()
      this.pollService.savePollAnswersforKyper(requestData).subscribe(
        (response) => {
          // this.appState.updateAcrossSteps(this.appState.get('DailyStepsData'),'polls', poll?.screen?.content?.id, { isCompleted: true })
          // this.enableFinalizeButton = false
          // this.spinnerService.off()
          // this.getRankAnswers(response)
          let path = this.appState.get('currentPath')
        let stepScreens = path?.kyperChapters?.[this.chapterIndex]?.steps?.[this.stepIndex]?.screens?.[this.currentIndex]?.screenContents
         if (stepScreens) {
          stepScreens.isCompleted = true;
          if(!stepScreens.userResponse){
            stepScreens.userResponse={}
          }
          stepScreens.userResponse = response.data?.answer
          stepScreens.userResponse.stats = response.data?.answer?.stats
        }
         let dailyStepsData = this.appState.get('DailyStepsData');
        let dailyStepScreens = dailyStepsData?.[this.chapterIndex]?.steps?.[this.stepIndex]?.screens?.[this.currentIndex]?.screenContents;
         if (dailyStepScreens) {
          dailyStepScreens.isCompleted = true;
          if(!dailyStepScreens.userResponse){
            dailyStepScreens.userResponse={}
          }
          dailyStepScreens.userResponse = response.data?.answer
          dailyStepScreens.userResponse.stats = response.data?.answer?.stats
        }
        this.appState.set('DailyStepsData', dailyStepsData);
        this.appState.set('currentPath', path)
          this.optionsList = response.data?.answer?.rankedOptions;
          // this.spinnerService.off()
                   this.poll.screen.userResponse =  response.data?.answer
        // Mark completed only now that the server stored the ranking (drives the mandatory gate).
        this.poll.screen.isCompleted = true;
          this.stats = response.data?.answer?.stats
          this.setStats()
          setTimeout(() => {
            this.enableBlur(this.enableFinalizeButton);
          }, 500);
          this.cdRef.detectChanges()

        },
        (error) => {
          // this.spinnerService.off()
             this.poll.screen.isCompleted = false;
          this.tostrService.error(this.i18n.t("Server or connection issue. Please check your internet connection."))
        }
      )
    }
  }

  async presentPopover(ev) {
    const dynamicText = this.i18n.t('These numbers show the percentage of your colleagues who ranked each option #1.');
    const popover = await this.popover.create({
      component: PopoverComponent,
      translucent: true,
      event: ev,
      mode:'ios',
      showBackdrop: true,
      cssClass: 'force-rank-popover',
      componentProps: {
        dynamicText: dynamicText,
      },
    });
    await popover.present();
    await popover.onDidDismiss();
  }


}
